import React, { Component } from 'react';
import moment from 'moment';

import ParkingConnlocationsSettingForm from './ParkingConnlocationsSettingForm';
import ParkingConnlocationsPasswordForm from './ParkingConnlocationsPasswordForm';

import { defaultSorter, dateSorter } from './Helpers';
import ParkingConnlocationsModel from './ParkingConnlocationsModel';
import UserModel from './UserModel';

import { Table, Badge, Divider, Row, Col, Statistic, Popconfirm, Typography, message, Card, Tooltip } from 'antd';

class ParkingConnlocationsTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    parkingconnFormData: null,
    parkingconnPasswordFormData: null
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  expandedRowRender(record) {
    const driverType = record.driverType
    return (
      <div>
        <Row style={{ marginBottom: 20 }}>
          <Col span={24}>
            <Card title="Popis">
              {record.description ? record.description : " - "}
            </Card>
          </Col>
          <Col span={2}>
            <Card title="Typ">
              {record.requestType ? record.requestType : " - "}
            </Card>
          </Col>
          <Col span={6}>
            <Card title="Jméno">
              {record.name ? record.name : " - "}
            </Card>
          </Col>
          {(driverType != 'SKIdata') && (
            <Col span={6}>
              <Card title="Url">
                {record.protocol + '://' + record.ipAddress + (record.port ? ':' + record.port : '')}
              </Card>
            </Col>
          )}
          {(driverType == 'Cross-PS4' || driverType == 'Green-Rest-5.4' || driverType == 'Green-WebInterface-5.3.0' || driverType == 'ASParking-V1' || driverType == 'SKIdata') && (
            <Col span={2}>
              <Card title="ParkId">
                {record.parkId !== null && record.parkId !== undefined ? record.parkId : (driverType === 'Cross-PS4' ? "1" : "-")}
              </Card>
            </Col>
          )}
          {(driverType == 'Invipo-Parking-V2' || driverType == 'SKIdata') && (
            <Col span={4}>
              <Card title="Area">
                {record.area ? record.area : "-"}
              </Card>
            </Col>
          )}
          {UserModel.isInRoles(['ADMIN', 'PARKINGCONN_PARKINGLOCATIONS_WRITE']) &&
            (
              (driverType == 'Invipo-Parking-V2') && (
                <Col span={5}>
                  <Card title="Token">
                    {record.token ? record.token : "-"}
                  </Card>
                </Col>
              )
            )
          }
        </Row>
        <Row>
          {(driverType == 'Cross-PS4' || driverType == 'Green-Rest-5.4' || driverType == 'SKIdata' || driverType == 'Parkinto-V1') && (
            <Col span={2}>
              <Card title="Login">
                {record.login ? record.login : "-"}
              </Card>
            </Col>
          )}
          {UserModel.isInRoles(['ADMIN', 'PARKINGCONN_PARKINGLOCATIONS_WRITE']) &&
            (
              (driverType == 'Cross-PS4' || driverType == 'Green-Rest-5.4' || driverType == 'ASParking-V1' || driverType == 'SKIdata' || driverType == 'Parkinto-V1') && (
                <Col span={5}>
                  <Card title="Heslo">
                    {record.password ? record.password : '-'}
                  </Card>
                </Col>
              )
            )
          }
          {(driverType == 'SKIdata') && (
            <Col span={3}>
              <Card title="FacilityId">
                {record.facilityId ? record.facilityId : "-"}
              </Card>
            </Col>
          )}
        </Row>
      </div >
    );
  }

  render() {

    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Lohalita',
      dataIndex: 'parkingLocationName',
      key: 'parkingLocationName',
      width: 250,
      sorter: (a, b) => defaultSorter(a.parkingLocationName, b.parkingLocationName),
    }, {
      title: 'Driver',
      dataIndex: 'driverType',
      key: 'driverType',
      width: 140,
      sorter: (a, b) => defaultSorter(a.driverType, b.driverType),
      render: (text, record) => {
        if (record.driverType == 'Green-WebInterface-5.3.0') {
          return 'Green-Web-5.3.0';
        } else {
          return record.driverType;
        }
      }
    }, {
      title: 'Poslední zjišťování',
      dataIndex: 'lastGetTime',
      key: 'lastGetTime',
      width: 180,
      sorter: (a, b) => dateSorter(a.lastGetTime, b.lastGetTime),
      render: (text, record) => {
        if (!record.lastGetTime) {
          return "-"
        } else {
          if (moment(record.lastGetTime) <= moment().subtract(120, "minutes")) {
            return (
              <Badge
                status="error"
                text={moment(text).format('L LTS')}
                title="Poslední komunikace před více než 2 hodinami" />
            );
          } else if (moment(record.lastGetTime) <= moment().subtract(60, "minutes")) {
            return (
              <Badge
                status="warning"
                text={moment(text).format('L LTS')}
                title="Poslední komunikace před více než 60 minutami" />
            );
          } else {
            return (
              <Badge
                status="success"
                text={moment(text).format('L LTS')}
                title="Vpořádku" />
            );
          }
        }
      }
    }, {
      title: 'Poslední změna stavu',
      dataIndex: 'timestamp',
      key: 'timestamp',
      width: 180,
      sorter: (a, b) => dateSorter(a.timestamp, b.timestamp),
      render: (text, record) => {
        return record.timestamp ? moment(text).format('L LTS') : '-'
      }

    }, {
      title: 'Kapacita',
      dataIndex: 'capacity',
      key: 'capacity',

      sorter: (a, b) => defaultSorter(a.capacity, b.capacity)
    }, {
      title: 'Obsazeno',
      dataIndex: 'latestOcc',
      key: 'latestOcc',

      sorter: (a, b) => defaultSorter(a.latestOcc, b.latestOcc),
    }, {
      title: 'Aktivní',
      dataIndex: 'active',
      key: 'active',
      width: 70,
      align: 'center',
      filters: [{
        text: 'ANO',
        value: true,
      }, {
        text: 'NE',
        value: false,
      }],
      filteredValue: filteredInfo.active || null,
      onFilter: (value, record) => { return ((record.active === value)) ? true : false },
      render: (text, record) => {
        if (record.active === true) {
          return (
            <Badge
              status="success"
            />
          );
        } else {
          return (
            <Badge
              status="error"
            />
          );
        }
      }
    }, {
      title: 'Upozornění',
      dataIndex: 'reportsEnabled',
      key: 'reportsEnabled',
      width: 100,
      filters: [{
        text: 'ZAPNUTO',
        value: true,
      }, {
        text: 'VYPNUTO',
        value: false,
      }],
      filteredValue: filteredInfo.reportsEnabled || null,
      onFilter: (value, record) => { return ((record.reportsEnabled === value)) ? true : false },
      render: (text, record) => {
        if (record.reportsEnabled === true) {
          return (
            <Badge
              status="success"
              text="ZAPNUTO" />
          );
        } else {
          return (
            <Badge
              status="error"
              text="VYPNUTO" />
          );
        }
      }
    }, {
      title: 'Akce',
      key: 'Action',
      width: 250,
      render: (text, record) => {
        const driverType = record.driverType
        if (UserModel.isInRoles(['ADMIN', 'PARKINGCONN_PARKINGLOCATIONS_WRITE'])) {
          return (
            <div>
              <a onClick={(e) => {
                this.setState({
                  parkingconnFormData: record
                });
              }}>Nastavení</a>
              <Divider type="vertical" />

              {(driverType == 'Cross-PS4' || driverType == 'Green-Rest-5.4' || driverType == 'ASParking-V1' || driverType == 'SKIdata') && (
                <span>
                  <a onClick={(e) => {
                    this.setState({
                      parkingconnPasswordFormData: record
                    });
                  }}>Změna hesla</a>
                  <Divider type="vertical" />
                </span>
              )}

              <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                this.props.onRemoveRow
                  ? this.props.onRemoveRow(record.id)
                  : null;
              }} okText="Ano" cancelText="Ne">
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </div>
          );
        }
      }
    }]

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          style={{ border: '0px' }}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }}
          onChange={this.handleChange}
          expandedRowRender={this.expandedRowRender.bind(this)}
          rowSelection={
            this.props.rowSelection !== undefined
              ? this.props.rowSelection
              : null
          }
        />
        <ParkingConnlocationsSettingForm
          type="modal"
          modalVisible={this.state.parkingconnFormData === null ? false : true}
          initialValues={this.state.parkingconnFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ parkingconnFormData: null });
          }}
          onSuccess={(form, values) => {
            ParkingConnlocationsModel.patch(this.state.parkingconnFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  parkingconnFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
        <ParkingConnlocationsPasswordForm
          type="modal"
          modalVisible={this.state.parkingconnPasswordFormData === null ? false : true}
          initialValues={this.state.parkingconnPasswordFormData}
          onModalCancel={(form) => {
            this.setState({ parkingconnPasswordFormData: null });
            form.resetFields();
          }}
          onSuccess={(form, values) => {
            ParkingConnlocationsModel.patch(this.state.parkingconnPasswordFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  parkingconnPasswordFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
      </div>
    );
  }
}

export default ParkingConnlocationsTable;


// WEBPACK FOOTER //
// ./src/components/ParkingConnlocationsTable.js